// extracted by mini-css-extract-plugin
export default {"header":"zuk5Fa1A","headerItemsContainer":"OK_NB8YI","appTitle":"PZFeydle","logo":"fBBZAkmr","headerRight":"am6zXPV2"};